import React from 'react';

const CError = ({msg, onDeleteError}) => {
  
  const onClickClose = () => {
    if (typeof onDeleteError === "function") {
      onDeleteError()
    }
  }
  
  return (
    <div className="notification is-danger">
      <button className="delete" onClick={onClickClose}/>
      {msg}
    </div>
  );
};

export default CError